import * as actionTypes from "../../constants/actionTypes";

const resetHasChangedFilters = () => {
  return {
    type: actionTypes.RESET_HAS_CHANGED_FILTERS
  };
};

const updateHasChangedFilter = id => {
  return {
    type: actionTypes.UPDATE_HAS_CHANGED_FILTER,
    id
  };
};

export { resetHasChangedFilters, updateHasChangedFilter };
